// Utils
import { appendOpacityValueToColour } from '../../../common/utils/colours';
import { BackgroundStatusCategories } from '../types/BackgroundStatusCategories';
/**
 * @deprecated Do not use legacy components anymore.
 * @param theme default theme
 * @param status current status
 * @returns color
 */
export var getBackgroundColorForStatus = function (_a, status) {
    var _b;
    var _c;
    var recordsFinancialPrimary = _a.recordsFinancialPrimary, disabledGradient = _a.disabledGradient, backgroundNegative = _a.backgroundNegative;
    var backgroundColorForStatus = (_b = {},
        _b["".concat(BackgroundStatusCategories.Active, "0")] = appendOpacityValueToColour(recordsFinancialPrimary, 0),
        _b["".concat(BackgroundStatusCategories.Active, "1")] = appendOpacityValueToColour(recordsFinancialPrimary, 10),
        _b["".concat(BackgroundStatusCategories.Active, "2")] = appendOpacityValueToColour(recordsFinancialPrimary, 20),
        _b["".concat(BackgroundStatusCategories.Active, "3")] = appendOpacityValueToColour(recordsFinancialPrimary, 27),
        _b[BackgroundStatusCategories.Active] = appendOpacityValueToColour(recordsFinancialPrimary, 35),
        _b["".concat(BackgroundStatusCategories.Disabled, "0")] = disabledGradient[100],
        _b["".concat(BackgroundStatusCategories.Disabled, "1")] = disabledGradient[200],
        _b["".concat(BackgroundStatusCategories.Disabled, "2")] = disabledGradient[300],
        _b["".concat(BackgroundStatusCategories.Disabled, "3")] = disabledGradient[400],
        _b[BackgroundStatusCategories.Disabled] = disabledGradient[500],
        _b[BackgroundStatusCategories.Error] = "".concat(backgroundNegative),
        _b);
    return (_c = backgroundColorForStatus[status]) !== null && _c !== void 0 ? _c : backgroundNegative;
};
//# sourceMappingURL=getBackgroundColorForStatus.js.map